import List from "./features/List";
import Filter from "./features/Filter";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useReadTaxList} from "./hooks/useReadTaxList";
import {TaxInvoiceListElementType, TaxInvoiceSearchParamType} from "./interface";
import {taxInvoiceListMapInit, taxInvoiceSearchParamInit} from "./state";
import moment from "moment/moment";

export default function TaxInvoice() {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const [searchParam, setSearchParam] = useState<TaxInvoiceSearchParamType>((() => ({
        ...taxInvoiceSearchParamInit,
        fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
    }))())
    const [selectedItems, setSelectedItems] = useState<TaxInvoiceListElementType[]>([])

    const {data: tax} = useReadTaxList({param: searchParam});

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    return <>
        <Filter searchParam={searchParam}
                setSearchParam={setSearchParam}
                setSelectedItems={setSelectedItems}/>

        <List tax={tax ?? taxInvoiceListMapInit}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}/>
    </>

}